/** Same per-user localStorage "last seen" convention as signalAlerts.js — lets the
 *  Notifications tab (and, later, any bell that wants an unread count) know how many
 *  admin broadcast messages are new since the user last opened the tab, without
 *  needing per-user read-state on the backend. */
export function getNotificationsLastSeenKey(user) {
  if (!user) return null;
  return `stockxignal_notifications_last_seen_${user.id || user.email || 'anon'}`;
}

export function markNotificationsSeen(user) {
  const key = getNotificationsLastSeenKey(user);
  if (!key) return;
  localStorage.setItem(key, String(Date.now()));
  window.dispatchEvent(new Event('sx-notifications-seen'));
}
